<template>
  <router-link :to="link" tag="li" class="nav-item nav-selection" @click.native.prevent.capture="$router.push(link)">
    <a :id="type + 'SelectionLink'" :title="$t('selection:' + type, {count:selection.length})" class="nav-link position-relative">
      <i v-if="selection.length" class="icon-cart-full" />
      <i v-else class="icon-cart-empty" />

      <span class="d-sm-none d-md-block d-lg-none notifications-badge badge badge-pill">{{ selection.length }}</span>

      <span class="d-md-none d-lg-inline-block mx-1">{{ $t('selection:label') | capitalize }}</span>
      <span class="d-md-none d-lg-inline-block">({{ $t('selection:' + type, {count:selection.length}) }})</span>
    </a>
  </router-link>
</template>

<script>
export default {
  props: {
    // Current selection
    selection: {
      type: Array,
      required: true
    },
    // Link for selection page
    link: {
      type: String,
      required: true
    },
    // Type of object in selection
    type: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
  @import "~@/scss/variables";

  .nav-selection {
    font-weight: 500;

    & > a > i {
      color: inherit;
    }
  }

  .notifications-badge {
    top: 7px;
    right: 0;
    background: $secondary;
  }
</style>
